import React from 'react';
import BaseIcon from './BaseIcon';

interface XIconProps {
  className?: string;
}

const XIcon: React.FC<XIconProps> = ({ className = "w-5 h-5" }) => (
  <BaseIcon className={className}>
    <path d="M18 6 6 18"></path>
    <path d="M6 6l12 12"></path>
  </BaseIcon>
);

export default XIcon;
